export default {"src":"/_next/static/media/improved-user-experience.73f78b68.svg","height":326,"width":409,"blurWidth":0,"blurHeight":0};